import { FormState, useWatch } from '@vtex/admin-ui-form'
import { MoreForLessBenefitEditor, MoreForLessTriggerEditor } from '..'
import { BenefitDescription } from './Description'
import { MoreForLessDiscount } from './Discount'
import { Illustration } from './Illustration'
import styles from './styles'

type Props = {
  name: string
  form: FormState
  trigger: MoreForLessTriggerEditor
}

export function BenefitEditor(props: Props) {
  const { form, name, trigger } = props

  const benefit: MoreForLessBenefitEditor = useWatch({
    form,
    name,
  })

  return (
    <div className={styles.container}>
      <BenefitDescription name={name} form={form} trigger={trigger} />

      <Illustration config={{ trigger, benefit }} />

      <MoreForLessDiscount form={form} name={`${name}.discount`} />
    </div>
  )
}
